import React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";

const borderedStyle = css`
padding: 16px;
border-radius: 12px;
border: 1px solid #DEDEDE;
background: #F7F7F7;

@media screen and (max-width: 320px) {
    padding: 16px 8px;
}
`;
const Box = styled.div`
${props => !props.noBorder && borderedStyle}
`;

const Title = styled.div`
padding-bottom: 8px;
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: normal;
color: #101415;
text-align: center;
`;

const Text = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #808080;
text-align: left;
`;

const TermsConditions = ({ title, rule, noBorder = 0 }) => {
  const { t } = useTranslation();

  return (
    <Box noBorder={noBorder}>
      <Title>{`${title} ${t("common.termsAndConditions")}`}</Title>
      <Text dangerouslySetInnerHTML={{ __html: rule }} />
    </Box>
  );
};

export default TermsConditions;
